<template>
	<div class="container">
		<div class="row center">
		    <p><i class="fa fa-warning"></i></p>
			<h2>404_error</h2>
			<h3>您访问的页面不存在</h3>
			<h1>即将 跳转到 首页</h1>
		</div>
	</div>
</template>

<style scoped>
.container{background:#00BFFF;}
.row{padding-top:5rem;line-height: 4rem;color:#555;}	
i{font-size: 3rem;}
</style>

<script>

export default {
   data:function(){
   	return {

   	}
   },
   created:function(){
   	  var _this=this;
   	  setTimeout(function(){
        _this.$router.replace("/");
   	  },3000)
   }
}	
</script>


// WEBPACK FOOTER //
// src/components/other/page404.vue